// Port of api/fuel/app/classes/filter/package/games/rating/package/recent.php
import F from 'offline/filter/constants'
export default {
	run: function(pkg, local, global) {
		if (global.ownerType === F.OWNER_USER) return pkg
		pkg.recent = []
		var revisions = (global.revisions && global.revisions[local.game_id]) ? global.revisions[local.game_id] : []
		var subUserIndex = []
		var seen = {}
		for (var i = revisions.length - 1; i >= 0; i--) {
			if (!seen[revisions[i].user_id]) {
				seen[revisions[i].user_id] = true
				subUserIndex.unshift(revisions[i].user_id)
			}
		}
		if (subUserIndex.length > 3) subUserIndex = subUserIndex.slice(-3)

		for (var j = 0; j < subUserIndex.length; j++) {
			var subUserId = subUserIndex[j]
			var comments = (global.comments && global.comments[subUserId]) ? global.comments[subUserId] : []
			var comment = false

			for (var c = 0; c < comments.length; c++) {
				if (comments[c].game === local.game_id) {
					comment = {
						user: comments[c].user,
						date: comments[c].date,
						text: comments[c].text
					}
				}
			}

			var recent = {
				user: parseInt(subUserId, 10),
				value: 0,
				count: 0,
				date: 0,
				comment: comment,
				history: [],
				change: 0
			}

			for (var k = 0; k < revisions.length; k++) {
				var revision = revisions[k]
				if (parseInt(revision.user_id, 10) !== parseInt(subUserId, 10)) continue

				recent.count++
				recent.value = Math.round(parseFloat(revision.log_rating || 0) * 10) / 10
				recent.date = parseInt(revision.log_date || 0, 10)
				recent.change = recent.count > 1 ? recent.value - recent.history[recent.count - 2].value : 0
				recent.history.push({
					value: Math.round(parseFloat(revision.log_rating || 0) * 10) / 10,
					date: parseInt(revision.log_date || 0, 10),
					initial: parseInt(revision.log_initial_sync || 0, 10)
				})
			}

			recent.count -= 1
			pkg.recent.push(recent)
		}
		pkg.recent = pkg.recent.reverse()
		return pkg
	}
}
